import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { CallDealerLogsRequestModal, DealerWiseCallHistoryRequest } from './../business-entities/call-dealer-logs-model';
import { CallDealerLogsDataService } from './../data-services/call-dealer-logs-data.service';

@Injectable({
  providedIn: 'root',
})
export class CallDealerLogsService {
  callDealerLogRequestModal: CallDealerLogsRequestModal = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    dealerId:'',
    selectedDate: '',
    applicationId:0,
    isExport :false,
  };
  dealerWiseCallHistoryRequestModal: DealerWiseCallHistoryRequest = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    selectedDealers:[],
    selectedDate: '',
    isExport :false,
  };

  constructor(private callDealerLogsDataService: CallDealerLogsDataService) {}

  async getCallDealerLogs(
    requestModel: CallDealerLogsRequestModal
  ): Promise<GenericResponse<any>> {
    return this.callDealerLogsDataService.getCallDealerLogs(requestModel);
  }
  async GetDealerWiseCallHistory(requestModel: DealerWiseCallHistoryRequest): Promise<GenericResponse<any>> {
    return this.callDealerLogsDataService.GetDealerWiseCallHistory(requestModel);
  }
}
